var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.images.length>0)?_c('div',[_c('van-swipe',{staticClass:"my-swipe",attrs:{"autoplay":300000}},_vm._l((_vm.images),function(image,index){return _c('van-swipe-item',{key:index},[_vm._t("default")],2)}),1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }